import PropTypes from "prop-types";
import Thumb from "./Thumb";

/*
 * Step 1. A refund request carries a single `ProductId`, so the rows are
 * radios: one item per request. The quantity chosen travels in the reason
 * text, which is the only free field the API has.
 */
const ItemPicker = ({ lines, selected, quantity, onSelect, onQuantity, formatPrice }) => (
  <ul className="c4rtn__items" role="radiogroup" aria-label="Items in this order">
    {lines.map((line) => {
      const isSelected = selected === line.id;
      const inputId = `c4rtn-item-${line.id}`;

      return (
        <li
          className={`c4rtn__item${isSelected ? " c4rtn__item--selected" : ""}`}
          key={line.id}
        >
          <label className="c4rtn__item-main" htmlFor={inputId}>
            <input
              className="c4rtn__radio"
              id={inputId}
              type="radio"
              name="c4rtn-item"
              value={line.id}
              checked={isSelected}
              onChange={() => onSelect(line.id)}
            />
            <span className="c4rtn__radio-mark" aria-hidden="true" />

            <Thumb image={line.image} name={line.name} />

            <span className="c4rtn__item-info">
              <span className="c4rtn__item-name">{line.name}</span>
              <span className="c4rtn__item-meta">
                Ordered {line.quantity}
                {line.lineTotal != null ? ` · ${formatPrice(line.lineTotal)}` : ""}
              </span>
            </span>
          </label>

          {isSelected && line.quantity > 1 ? (
            <div className="c4rtn__qty">
              <label className="c4rtn__qty-label" htmlFor={`${inputId}-qty`}>
                Return qty
              </label>
              <select
                className="c4rtn__select"
                id={`${inputId}-qty`}
                value={quantity}
                onChange={(e) => onQuantity(Number(e.target.value))}
              >
                {Array.from({ length: line.quantity }, (_, i) => i + 1).map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </select>
            </div>
          ) : null}
        </li>
      );
    })}
  </ul>
);

ItemPicker.propTypes = {
  lines: PropTypes.array.isRequired,
  selected: PropTypes.string,
  quantity: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  onQuantity: PropTypes.func.isRequired,
  formatPrice: PropTypes.func.isRequired,
};

export default ItemPicker;
